import React from "react";


const PaymentMethodSelectorContext= React.createContext({});

const PaymentMethodSelectorProvider = ({ children }) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState("");
  const [transactionFeePolicy, setTransactionFeePolicy] = React.useState("");
  const [transactionAmount, setTransactionAmount] = React.useState("");
  // pg fee of the selected payment method returned by backend
  const [pgFee, setPgFee] = React.useState("");

  return (
    <PaymentMethodSelectorContext.Provider
      value={{
        selectedPaymentMethod,setSelectedPaymentMethod , transactionFeePolicy, setTransactionFeePolicy, transactionAmount, setTransactionAmount, pgFee, setPgFee
      }}
    >
      {children}
    </PaymentMethodSelectorContext.Provider>
  );
};

const usePaymentMethodSelector = () => {
  const val = React.useContext(PaymentMethodSelectorContext);
  return val;
};

export { PaymentMethodSelectorProvider, usePaymentMethodSelector};
